import { useImperativeHandle, forwardRef } from 'react';
import { Form, Row, Col } from 'antd';
import PropTypes from 'prop-types';

const XForm = (props, xForm) => {
    const [form] = Form.useForm();
    const { formApis = {}, formItems = [] } = props;
    useImperativeHandle(
        xForm,
        () => ({
            // 暴露给父组件的方法
            form,
        }),
        [form],
    );

    /* eslint-disable no-template-curly-in-string */
    const validateMessages = {
        required: '${label}不能为空',
    };
    /* eslint-enable no-template-curly-in-string */

    const formItemRender = (formItems = [], setCol, noStyle, inIndex = 0) => {
        return (formItems.filter(item => item) || []).map((formItem, index) => {
            const {
                formItemApis = {},
                item,
                id = `id_${index}`,
                formItemSpan = 24,
                notFormItem = false,
                setItemCol = true,
            } = formItem;
            const { name, ...otherApi } = formItemApis;
            const itemKey = `${name || 'item'}_${index}_${inIndex}`;
            let itemRender = Array.isArray(item) ? (
                <Form.Item {...otherApi} key={itemKey}>
                    {formItemRender(item, setCol, true, inIndex + 1)}
                </Form.Item>
            ) : notFormItem ? (
                <span key={itemKey}>{item}</span>
            ) : (
                <Form.Item name={name} {...formItemApis} noStyle={noStyle} key={itemKey}>
                    {item}
                </Form.Item>
            );
            if (id) {
                // id属性用于点击锚点跳转item位置
                itemRender = (
                    <span id={id} key={itemKey}>
                        {itemRender}
                    </span>
                );
            }
            if (setCol && setItemCol) {
                itemRender = (
                    <Col span={formItemSpan} key={itemKey}>
                        {itemRender}
                    </Col>
                );
            }
            return itemRender;
        });
    };

    return (
        <Form form={form} {...formApis} validateMessages={validateMessages} scrollToFirstError>
            {['inline', 'vertical'].includes(formApis.layout) ? (
                // formItem 平铺 适用于列表顶部搜索条件等情况
                formItemRender(formItems)
            ) : (
                // 设置formItem占宽
                <Row>{formItemRender(formItems, true)}</Row>
            )}
        </Form>
    );
};
export default forwardRef(XForm);

XForm.propTypes = {
    formApis: PropTypes.object,
    formItems: PropTypes.array,
};

/* 表单组件应用实例
    // 利用xForm调用antd-form的api 例设置值：xFormRef.current.form?.setFieldsValue({})
    import { useRef } from 'react';
    import XForm from 'components/XForm';
    const xFormRef = useRef();
    const formItems = [
        {
            formItemApis: {
                label: 'input',
                help: null,
                name: 'userId',
                rules: [{ required: true, message: '' }],
            },
            item: <Input />,
            formItemSpan: 24, //formItem 占宽，默认占一整行 0~24
            notFormItem: false // 非formItem 例：右侧提示
        },
        {
            item: (
                <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                    Submit
                </Button>
            ),
        },
    ];
    <XForm
        formApis={{
            name: 'login',
            onFinish: onFinish,
            onFinishFailed: onFinishFailed,
        }}
        formItems={formItems}
        ref={xFormRef}
    />
*/
